import React, { FunctionComponent } from 'react';

type Props = {
  flashType: string;
  type?: string;
  recently?: string;
  flashMessage: string;
};

export const Presentation: FunctionComponent<Props> = ({ flashType, type, recently, flashMessage }) => {

  return (
    <div className={`alert-fixed alert-${flashType} ${type === 'personShow' ? type : ''}`}>
      <p>
        {recently && <span className="registered">登録日：{recently}</span>}
        {flashMessage}
      </p>
    </div>
  );
};
